var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tableContainer", attrs: { id: _vm.scrollId } },
    [
      _c("table", { staticClass: "custom-table" }, [
        _c(
          "thead",
          { staticClass: "sticky-header" },
          [
            _c(
              "tr",
              [
                _vm.checkbox
                  ? _c(
                      "th",
                      {
                        staticClass: "headerText",
                        style: {
                          borderBottom: _vm.tableLines
                            ? "none"
                            : "1px solid #ddd"
                        }
                      },
                      [
                        _c("InputField", {
                          attrs: {
                            value: _vm.isSelectAll,
                            checkboxOptions: [{ id: 1 }],
                            inputType: "checkbox"
                          },
                          on: {
                            input: function($event) {
                              _vm.isSelectAll = !_vm.isSelectAll
                            }
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm._l(_vm.headers, function(header, index) {
                  return _c(
                    "th",
                    {
                      key: header.value,
                      staticClass: "headerText",
                      style: {
                        borderBottom: _vm.tableLines
                          ? "none"
                          : "1px solid #ddd",
                        width: header.width !== null ? header.width : "auto"
                      }
                    },
                    [
                      _c("span", { staticClass: "headerText" }, [
                        _vm._v(
                          _vm._s(
                            header.required ? header.text + "*" : header.text
                          ) + " "
                        )
                      ]),
                      _vm._v(" "),
                      _vm.sortable &&
                      _vm.sortOrders[index] === null &&
                      (header.sortable !== undefined ? header.sortable : true)
                        ? _c(
                            "v-icon",
                            {
                              staticClass: "sortIcon",
                              on: {
                                click: function($event) {
                                  return _vm.sortClick(index, "asc")
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n            arrow_drop_down\n          "
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.sortable &&
                      _vm.sortOrders[index] === "desc" &&
                      (header.sortable !== undefined ? header.sortable : true)
                        ? _c(
                            "v-icon",
                            {
                              staticClass: "sortIcon",
                              on: {
                                click: function($event) {
                                  return _vm.sortClick(index, null)
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n            arrow_drop_down\n          "
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.sortable &&
                      _vm.sortOrders[index] === "asc" &&
                      (header.sortable !== undefined ? header.sortable : true)
                        ? _c(
                            "v-icon",
                            {
                              staticClass: "sortIcon",
                              on: {
                                click: function($event) {
                                  return _vm.sortClick(index, "desc")
                                }
                              }
                            },
                            [_vm._v("\n            arrow_drop_up\n          ")]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                }),
                _vm._v(" "),
                _vm.actionButtons
                  ? _c("th", {
                      staticClass: "headerText",
                      style: {
                        borderBottom: _vm.tableLines ? "none" : "1px solid #ddd"
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.conflicts
                  ? _c(
                      "th",
                      {
                        staticClass: "headerText",
                        style: {
                          borderBottom: _vm.tableLines
                            ? "none"
                            : "1px solid #ddd",
                          textTransform: "none"
                        }
                      },
                      [
                        _c("input-field", {
                          key: "globalConflicts",
                          attrs: {
                            "input-type": "radio",
                            value: _vm.globalConflicts,
                            size: "large",
                            inputContainerAlign: "flex-end",
                            inputFieldColor: "var(--app-primary-base)",
                            inputFieldContainerStyling: { padding: "0" },
                            radioOptions: [
                              { value: "New", label: "New" },
                              { value: "Old", label: "Old" }
                            ]
                          },
                          on: {
                            input: function($event) {
                              return _vm.updateGlobalConflicts($event)
                            }
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.customButton
                  ? _c("th", {
                      staticClass: "headerText",
                      style: {
                        borderBottom: _vm.tableLines ? "none" : "1px solid #ddd"
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.addRowButton
                  ? _c(
                      "div",
                      { staticClass: "addRowButton" },
                      [
                        _c("CustomButton", {
                          attrs: {
                            icon: "add",
                            width: "20px",
                            height: "20px",
                            iconSize: 12,
                            buttonStyling: {
                              padding: "8px",
                              borderRadius: "4px"
                            }
                          },
                          on: { buttonClick: _vm.handleAdd }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ],
              2
            ),
            _vm._v(" "),
            _vm.loading
              ? _c("v-progress-linear", {
                  staticClass: "loadingBar",
                  attrs: {
                    indeterminate: "",
                    color: "var(--app-primary-base)",
                    "background-opacity": "0.20"
                  }
                })
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "tbody",
          [
            _c("div", { staticClass: "noDataContainer" }, [
              _vm.items.length === 0 || _vm.items === null
                ? _c("span", { staticClass: "noDataLabel" }, [
                    _vm._v(_vm._s(_vm.$t("NoData")))
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _vm._l(_vm.items, function(data, dataIndex) {
              return _c(
                "tr",
                {
                  key: dataIndex,
                  staticClass: "bodyRow",
                  class: { selectedRow: _vm.selectedRowIndex === dataIndex },
                  attrs: { id: "rowId" },
                  on: {
                    click: function($event) {
                      return _vm.rowClick(dataIndex)
                    }
                  }
                },
                [
                  _vm.checkbox
                    ? _c(
                        "td",
                        {
                          class: _vm.tdWidth,
                          style: {
                            borderBottom: _vm.tableLines
                              ? "none"
                              : "1px solid #ddd"
                          }
                        },
                        [
                          _c("InputField", {
                            attrs: {
                              inputType: "checkbox",
                              value: _vm.isSelected(dataIndex),
                              checkboxOptions: [{ id: dataIndex }]
                            },
                            on: {
                              input: function($event) {
                                return _vm.handleCheckboxChange(dataIndex)
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(_vm.headers, function(field, fieldIndex) {
                    return _c(
                      "td",
                      {
                        key: dataIndex + "-" + _vm.rowIndexKey,
                        staticClass: "rowText",
                        style: {
                          borderBottom: _vm.tableLines
                            ? "none"
                            : "1px solid #ddd"
                        }
                      },
                      [
                        !data.editable || !_vm.fieldIsEditable(field, dataIndex)
                          ? _c(
                              "span",
                              {
                                class: {
                                  password:
                                    data.isPassword && field.varName === "value"
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    field.varName
                                      ? _vm.getVarNameValue(data, field)
                                      : data.value
                                  )
                                )
                              ]
                            )
                          : _vm.actionButtons &&
                            data.editable &&
                            _vm.fieldIsEditable(field, dataIndex) &&
                            (field.type === "select" ||
                              field.type === "multiselect")
                          ? _c(
                              "input-field",
                              {
                                attrs: {
                                  "input-type": field.type,
                                  value: data[field.varName],
                                  placeholder: field.placeholder
                                    ? field.placeholder
                                    : null,
                                  "select-options-list": field.options,
                                  inputStyle: { border: "none" },
                                  "input-field-container-styling": {
                                    padding: "0",
                                    border: "none"
                                  }
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.$emit("input", {
                                      data: data,
                                      index: dataIndex,
                                      field: field,
                                      value: $event
                                    })
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(data[field.varName]) +
                                    "\n          "
                                )
                              ]
                            )
                          : _vm.actionButtons &&
                            data.editable &&
                            _vm.fieldIsEditable(field, dataIndex)
                          ? (field.type ? field.type : "text") === "checkbox"
                            ? _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: data[field.varName],
                                    expression: "data[field.varName]"
                                  }
                                ],
                                staticClass: "inputClass",
                                attrs: {
                                  placeholder: field.placeholder,
                                  min: field.min,
                                  max: field.max,
                                  step: field.step,
                                  type: "checkbox"
                                },
                                domProps: {
                                  checked: Array.isArray(data[field.varName])
                                    ? _vm._i(data[field.varName], null) > -1
                                    : data[field.varName]
                                },
                                on: {
                                  keypress: function($event) {
                                    return _vm.checkInput(
                                      $event,
                                      field.type,
                                      data[field.varName]
                                    )
                                  },
                                  change: function($event) {
                                    var $$a = data[field.varName],
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          _vm.$set(
                                            data,
                                            field.varName,
                                            $$a.concat([$$v])
                                          )
                                      } else {
                                        $$i > -1 &&
                                          _vm.$set(
                                            data,
                                            field.varName,
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1))
                                          )
                                      }
                                    } else {
                                      _vm.$set(data, field.varName, $$c)
                                    }
                                  }
                                }
                              })
                            : (field.type ? field.type : "text") === "radio"
                            ? _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: data[field.varName],
                                    expression: "data[field.varName]"
                                  }
                                ],
                                staticClass: "inputClass",
                                attrs: {
                                  placeholder: field.placeholder,
                                  min: field.min,
                                  max: field.max,
                                  step: field.step,
                                  type: "radio"
                                },
                                domProps: {
                                  checked: _vm._q(data[field.varName], null)
                                },
                                on: {
                                  keypress: function($event) {
                                    return _vm.checkInput(
                                      $event,
                                      field.type,
                                      data[field.varName]
                                    )
                                  },
                                  change: function($event) {
                                    return _vm.$set(data, field.varName, null)
                                  }
                                }
                              })
                            : _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: data[field.varName],
                                    expression: "data[field.varName]"
                                  }
                                ],
                                staticClass: "inputClass",
                                attrs: {
                                  placeholder: field.placeholder,
                                  min: field.min,
                                  max: field.max,
                                  step: field.step,
                                  type: field.type ? field.type : "text"
                                },
                                domProps: { value: data[field.varName] },
                                on: {
                                  keypress: function($event) {
                                    return _vm.checkInput(
                                      $event,
                                      field.type,
                                      data[field.varName]
                                    )
                                  },
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      data,
                                      field.varName,
                                      $event.target.value
                                    )
                                  }
                                }
                              })
                          : _vm._e()
                      ],
                      1
                    )
                  }),
                  _vm._v(" "),
                  _vm.actionButtons && !data.editable
                    ? _c(
                        "td",
                        {
                          staticClass: "rowText rowButtons",
                          style: {
                            borderBottom: _vm.tableLines
                              ? "none"
                              : "1px solid #ddd"
                          }
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "rowButtonsContainer" },
                            [
                              _c("CustomButton", {
                                attrs: {
                                  icon: "edit",
                                  width: "20px",
                                  height: "20px",
                                  iconSize: 12,
                                  buttonStyling: {
                                    padding: "8px",
                                    marginRight: "5px",
                                    borderRadius: "4px"
                                  }
                                },
                                on: {
                                  buttonClick: function($event) {
                                    return _vm.handleEdit(dataIndex)
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("CustomButton", {
                                attrs: {
                                  icon: "mdi-delete",
                                  width: "20px",
                                  height: "20px",
                                  disabled: _vm.deleteActionButtonDisable,
                                  iconSize: 12,
                                  buttonStyling: {
                                    padding: "8px",
                                    borderRadius: "4px"
                                  }
                                },
                                on: {
                                  buttonClick: function($event) {
                                    return _vm.handleDelete(dataIndex)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.hasImportsButtons
                    ? _c(
                        "td",
                        {
                          staticClass: "rowText rowButtons",
                          style: {
                            borderBottom: _vm.tableLines
                              ? "none"
                              : "1px solid #ddd"
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "rowButtonsContainer",
                              style: {
                                justifyContent: _vm.showValidate(data)
                                  ? "center"
                                  : "flex-end"
                              }
                            },
                            [
                              !_vm.isProcessing(data) && _vm.showValidate(data)
                                ? _c("custom-button", {
                                    attrs: {
                                      label: _vm.$t("Validate"),
                                      "button-color":
                                        _vm.selectedRowIndex === dataIndex
                                          ? "#FFF"
                                          : "var(--app-primary-base)",
                                      "label-color":
                                        _vm.selectedRowIndex === dataIndex
                                          ? "var(--app-primary-base)"
                                          : "#FFF",
                                      "button-styling": _vm.validateButtonsStyling(
                                        dataIndex
                                      )
                                    },
                                    on: {
                                      buttonClick: function($event) {
                                        return _vm.handleValidate(
                                          $event,
                                          data,
                                          dataIndex
                                        )
                                      }
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.isProcessing(data)
                                ? _c("v-progress-circular", {
                                    staticClass: "mr-3",
                                    attrs: {
                                      indeterminate: "",
                                      size: "20",
                                      width: "3",
                                      color: "accent"
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "v-icon",
                                {
                                  style: {
                                    cursor: "pointer",
                                    visibility:
                                      _vm.selectedRowIndex !== dataIndex
                                        ? "hidden"
                                        : "visible"
                                  },
                                  attrs: {
                                    size: 16,
                                    color: "var(--app-primary-base)",
                                    disabled: !_vm.hasDeletePermission
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.handleImportDelete(
                                        $event,
                                        dataIndex,
                                        _vm.selectedRowIndex !== dataIndex
                                      )
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s("mdi-delete") +
                                      "\n            "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.actionButtons && data.editable
                    ? _c(
                        "td",
                        {
                          staticClass: "rowText rowButtons",
                          style: {
                            borderBottom: _vm.tableLines
                              ? "none"
                              : "1px solid #ddd"
                          }
                        },
                        [
                          data.editable
                            ? _c(
                                "div",
                                { staticClass: "rowButtonsContainerSaveDel" },
                                [
                                  _c("CustomButton", {
                                    attrs: {
                                      icon: "done",
                                      width: "20px",
                                      height: "20px",
                                      iconSize: 12,
                                      buttonStyling: {
                                        padding: "8px",
                                        marginRight: "5px",
                                        borderRadius: "4px"
                                      }
                                    },
                                    on: {
                                      buttonClick: function($event) {
                                        return _vm.handleSave(dataIndex)
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("CustomButton", {
                                    attrs: {
                                      icon: "close",
                                      width: "20px",
                                      height: "20px",
                                      iconSize: 12,
                                      buttonStyling: {
                                        padding: "8px",
                                        borderRadius: "4px"
                                      }
                                    },
                                    on: {
                                      buttonClick: function($event) {
                                        return _vm.handleCancel(dataIndex)
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.conflicts
                    ? _c(
                        "td",
                        {
                          style: {
                            borderBottom: _vm.tableLines
                              ? "none"
                              : "1px solid #ddd"
                          }
                        },
                        [
                          _c("input-field", {
                            key: "conflicts-" + dataIndex,
                            attrs: {
                              "input-type": "radio",
                              value: _vm.getConflictValue(dataIndex),
                              size: "large",
                              inputContainerAlign: "flex-end",
                              inputFieldColor: "var(--app-primary-base)",
                              inputFieldContainerStyling: { padding: "0" },
                              radioOptions: [
                                { value: data.new_id, label: "New" },
                                { value: data.id, label: "Old" }
                              ]
                            },
                            on: {
                              input: function($event) {
                                if ($event.target !== $event.currentTarget) {
                                  return null
                                }
                                return _vm.updateConflicts($event, dataIndex)
                              },
                              click: function($event) {
                                $event.stopPropagation()
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.customButton
                    ? _c(
                        "td",
                        {
                          style: {
                            borderBottom: _vm.tableLines
                              ? "none"
                              : "1px solid #ddd"
                          }
                        },
                        [_vm._t("customButton", null, { data: data })],
                        2
                      )
                    : _vm._e()
                ],
                2
              )
            })
          ],
          2
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c3a612c2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c3a612c2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/newComponents/_Molecules/Table.vue
// module id = null
// module chunks = 